import { Subcategoria } from './subcategoria';
import { Tienda } from './tienda';

export class Categoria {
  id: number;
  nombre: string;
  imagen: string;
  orden: number;
  subcategorias: Array<Subcategoria>;
  tiendas?: Array<Tienda>;

  constructor(item: any) {
    this.id            = item.id_categoria;
    this.nombre        = item.nombre_categoria;
    this.imagen        = item.imagen_categoria;
    this.orden         = item.orden_categoria;
    this.subcategorias = item.sub_categorias.map((subcategoria: any) => new Subcategoria(subcategoria));
  }
}
